import tools from 'tools';

export default class ProductFilter {
    constructor() {
        this.$el = $('.product-filter');
        this.$resultPopup = this.$el.find('.product-filter-result-popup');

        this.$el.find('.product-filter-param__title').on('click', this.toggleOptionsList.bind(this));
        this.$el.find('.product-filter-param__show-all').on('click', this.showAllParamValues.bind(this));
        this.$el.find('[type="checkbox"]').on('change', this.onOptionClick.bind(this));
        this.$el.find('.product-filter-param__price-input').on('input', this.onPriceInput.bind(this));
        this.$el.find('.product-filter__submit').on('click', this.submit.bind(this));
        this.$el.find('.product-filter__reset').on('click', this.reset.bind(this));
        this.$el.find('.product-filter-param__fake-link').on('click', this.onParamFakeLinkClick.bind(this));
        $('.product-availability-filter [type="checkbox"]').on('change', this.onAvailabilityClick.bind(this));

        this.$sectionFilter = $(".section-filter__container");
        this.$sectionFilter.find(".section-filter__item").on('click', this.onSectionClick.bind(this));

        this.updateFilledState();
    }

    onSectionClick(e) {
        const inputId = e.currentTarget.getAttribute("data-filter-id");

        let inputForSectionFilterRefresh;
        if (!inputId) {
            $(".product-filter-param--PARENT_SECTION").find("input").each((i, item) => {
                item.checked = false;
                inputForSectionFilterRefresh = item;
            });
        } else {
            inputForSectionFilterRefresh = document.querySelector("#" + inputId);
            $(inputForSectionFilterRefresh).closest(".product-filter-param__options-wrapper").find("input").each((i, item) => {
                item.checked = false;
            })
            inputForSectionFilterRefresh.checked = true;
        }

        this.$lastChangedItemWrapper = this.$sectionFilter;
        smartFilter.click(inputForSectionFilterRefresh);
    }

    legacy() {
        //на узких экранах фильтры скрыты за кнопкой
        $('.catalog__filters-m-open-button').on('click', function () {
            $(this).closest('.catalog__filters-holder').find('.filters').slideToggle();
        });
    }

    toggleOptionsList(e) {
        const $param = $(e.currentTarget).closest('.product-filter-param');
        $param.toggleClass('.product-filter-param--collapsed').toggleClass('product-filter-param--expanded');

        $param.find('.product-filter-param__options-wrapper').slideToggle();
    }

    showAllParamValues(e) {
        const $param = $(e.currentTarget).closest('.product-filter-param');

        $param.find('.product-filter-param__option--secondary').removeClass('hidden');
        $param.find('.product-filter-param__show-all').addClass('hidden');
    }

    updateFilledState() {
        this.$el.find('.product-filter-param').each(function (index, el) {
            let type;

            if ($(el).hasClass('product-filter-param--price')) {
                type = 'price';
            } else {
                type = 'checkbox';
            }

            let filled;

            switch (type) {
                case 'price':
                    filled = $(el).find('.product-filter-param__price-input').filter(function (index, el) {
                        return ['0', ''].indexOf($(el).val()) == -1;
                    }).length > 0;
                    break;

                default:
                    filled = $(el).find(':checked').length > 0;
                    break;
            }

            $(el).toggleClass('product-filter-param--filled', filled);
        });
    }

    onOptionClick(e) {
        this.hideResultPopup();
        this.updateFilledState();
        this.$lastChangedItemWrapper = $(e.currentTarget).closest('.product-filter-param__option');
        smartFilter.click(e.currentTarget);
    }

    onPriceInput(e) {
        const $param = $(e.currentTarget).closest('.product-filter-param__price');
        this.$lastChangedItemWrapper = $(e.currentTarget).closest('.product-filter-param__options-wrapper');

        this.hideResultPopup();
        this.updateFilledState($param);
        smartFilter.keyup(e.currentTarget);
    }

    onAvailabilityClick(e) {
        document.location.href = $(e.currentTarget).attr('data-url');
    }

    updateItem(propertyId, arItem) {
        if (arItem.PROPERTY_TYPE === 'N' || arItem.PRICE) {
            let trackBar = window['trackBar' + propertyId];

            if (!trackBar && arItem.ENCODED_ID) {
                trackBar = window['trackBar' + arItem.ENCODED_ID];
            }

            if (trackBar && arItem.VALUES) {
                if (arItem.VALUES.MIN) {
                    if (arItem.VALUES.MIN.FILTERED_VALUE) {
                        trackBar.setMinFilteredValue(arItem.VALUES.MIN.FILTERED_VALUE);
                    } else {
                        trackBar.setMinFilteredValue(arItem.VALUES.MIN.VALUE);
                    }
                }

                if (arItem.VALUES.MAX) {
                    if (arItem.VALUES.MAX.FILTERED_VALUE) {
                        trackBar.setMaxFilteredValue(arItem.VALUES.MAX.FILTERED_VALUE);
                    } else {
                        trackBar.setMaxFilteredValue(arItem.VALUES.MAX.VALUE);
                    }
                }
            }
        } else if (arItem.VALUES) {
            for (let i in arItem.VALUES) {
                if (!arItem.VALUES.hasOwnProperty(i)) {
                    continue;
                }

                let value = arItem.VALUES[i];
                let $option = this.$el.find('.product-filter-param__option[data-for="' + value.CONTROL_ID + '"]');

                if ($option.length == 0) {
                    continue;
                }

                $option.toggleClass('product-filter-param__option--disabled', value.DISABLED === true);

                if ($option.hasClass('product-filter-param__option--checkbox')) {
                    $option.find('.gui-checkbox').toggleClass('gui-checkbox--disabled', value.DISABLED === true);
                    $option.find(':checkbox').prop('disabled', value.DISABLED === true);
                }
            }
        }
    }

    submit(e) {
        e.preventDefault();
        document.location.href = $(e.currentTarget).attr('data-url');
    }

    reset(e) {
        e.preventDefault();
        document.location.href = $(e.currentTarget).attr('data-url');
    }

    /**
     * Called in CJSmartFilter when server responses
     * @param {Object} response
     */
    onComponentResponse(response) {
        if (!response || !response.ITEMS) {
            // There is something wrong or nothing to change
            return;
        }

        for(let pid in response.ITEMS) {
            if (!response.ITEMS.hasOwnProperty(pid)) {
                continue;
            }

            this.updateItem(pid, response.ITEMS[pid]);
        }

        if (this.$lastChangedItemWrapper === this.$sectionFilter) {
            window.location.href = response.FILTER_URL;
        } else {
            this.showResultPopup(response.ELEMENT_COUNT, response.FILTER_URL);
            this.$el.find('.product-filter__submit').attr('data-url', response.FILTER_URL);
        }
    }

    onGetUrlInButton(response){
        const urlSearchParams = new URLSearchParams();

        for (const object of response) {
            if (object.name && object.value && object.name !=="ajax") {
                urlSearchParams.append(object.name, object.value);
            }
        }
        const currentUrl = window.location.href.split('?')[0];
        const newUrl = currentUrl + '?' +urlSearchParams.toString();
        this.$el.find('.product-filter__submit').attr('data-url', newUrl);
    }

    track(e) {
        this.$lastChangedItemWrapper = $(e.currentTarget).closest('.product-filter-param__options-wrapper');
    }
    /**
     * Show result popup under last changed param option
     * @param {number} count
     * @param {string} applyUrl
     */
    showResultPopup(count, applyUrl) {
        this.$resultPopup.find('.product-filter-result-popup__apply').attr('href', applyUrl);

        let text = tools.plural(parseInt(count, 10), 'Найден #count# товар', 'Найдено #count# товара', 'Найдено #count# товаров');
        this.$resultPopup.find('[data-var="text"]').text(text.replace('#count#', count));

        this.$lastChangedItemWrapper.after(this.$resultPopup);
        this.$resultPopup.toggleClass('hidden', false);
    }

    hideResultPopup() {
        this.$resultPopup.toggleClass('hidden', true);
    }

    onParamFakeLinkClick(e) {
        e.preventDefault();
        $(e.currentTarget).closest('label').click();
    }
}
